import NewMatterEvent from './NewMatterEvent'

export default {
    NewMatterEvent
}